import RoutesContainer from './routes/RoutesContainer';

export default RoutesContainer;
